import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetNotificationSubscriptionResData } from "./GetNotificationSubscriptionResData";

const ENDPOINT = "/notifications/subscriptions";

export class GetNotificationSubscriptionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetNotificationSubscriptionResData> {
        var res = await this.executeCommand();
        return new GetNotificationSubscriptionResData(res);
    }
}
